(() => {
  if (customElements.get('hb-pdp-btf')) return;
  customElements.define('hb-pdp-btf', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      const quality = this.querySelector('.hb-quality');
      quality?.classList.add('is-ready');
      const videos = [...this.querySelectorAll('video')];
      videos.forEach(video => {
        const play = video.nextElementSibling;
        if (!video.querySelector('source')) { video.controls = false; return; }
        video.controls = false;
        play.hidden = false;
        video.addEventListener('play', () => {
          play.hidden = true;
          videos.forEach(other => { if (other !== video) other.pause(); });
        }, { signal });
        video.addEventListener('ended', () => { video.controls = false; play.hidden = false; }, { signal });
      });
      const row = this.querySelector('.film-grid');
      const update = () => {
        const card = row.querySelector('.film');
        const gap = parseFloat(getComputedStyle(row).gap) || 15;
        const current = Math.min(2, Math.max(0, Math.round(row.scrollLeft / (card.getBoundingClientRect().width + gap))));
        this.querySelector('.story-count').textContent = `${current + 1} / 3`;
        this.querySelector('[data-slide="-1"]').disabled = row.scrollLeft < 2;
        this.querySelector('[data-slide="1"]').disabled = row.scrollLeft >= row.scrollWidth - row.clientWidth - 2;
      };
      row.addEventListener('scroll', update, { signal, passive: true });
      window.addEventListener('resize', update, { signal });
      update();
      this.addEventListener('click', e => {
        const button = e.target.closest('[data-dialog], [data-close-dialog], [data-play], [data-slide], [data-buy]');
        if (!button) return;
        if (button.hasAttribute('data-dialog')) {
          e.preventDefault();
          this.querySelector(`[id="${button.dataset.dialog}-${this.dataset.sectionId}"]`)?.showModal();
        } else if (button.hasAttribute('data-close-dialog')) button.closest('dialog').close();
        else if (button.hasAttribute('data-play')) {
          const video = button.previousElementSibling;
          video.controls = true;
          video.play().catch(() => { button.hidden = false; });
        } else if (button.hasAttribute('data-slide')) {
          row.scrollBy({ left: Number(button.dataset.slide) * (row.querySelector('.film').getBoundingClientRect().width + (parseFloat(getComputedStyle(row).gap) || 15)), behavior: reduced.matches ? 'auto' : 'smooth' });
        } else {
          e.preventDefault();
          let target;
          try { if (this.dataset.purchaseSelector) target = document.querySelector(this.dataset.purchaseSelector); } catch (_) {}
          if (!target) target = [...document.querySelectorAll('form[action*="/cart/add"]')].find(form => !this.contains(form) && form.getClientRects().length && (form.compareDocumentPosition(this) & Node.DOCUMENT_POSITION_FOLLOWING));
          if (target) {
            target.scrollIntoView({ behavior: reduced.matches ? 'auto' : 'smooth', block: 'center' });
            const focus = target.querySelector('button[type="submit"], input, button');
            focus?.focus({ preventScroll: true });
          } else window.scrollTo({ top: 0, behavior: reduced.matches ? 'auto' : 'smooth' });
        }
      }, { signal });
      const digits = [...this.querySelectorAll('[data-count-to]')];
      const finish = () => { cancelAnimationFrame(this.frame); digits.forEach(el => el.textContent = el.dataset.countTo); };
      if (digits.length && !reduced.matches && 'IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          if (!entries.some(e => e.isIntersecting)) return;
          this.observer.disconnect();
          const start = performance.now();
          const tick = now => {
            let done = true;
            digits.forEach((el, i) => {
              const t = Math.max(0, Math.min(1, (now - start - i * 100) / 1400));
              el.textContent = Math.round(Number(el.dataset.countTo) * (1 - Math.pow(1 - t, 3)));
              if (t < 1) done = false;
            });
            if (done) finish(); else this.frame = requestAnimationFrame(tick);
          };
          this.frame = requestAnimationFrame(tick);
        }, { threshold: 0.35 });
        this.observer.observe(this.querySelector('.results'));
        reduced.addEventListener('change', () => { if (reduced.matches) { this.observer.disconnect(); finish(); } }, { signal });
      }
      const buy = this.querySelector('[data-buy]'); const id = buy?.hash?.slice(1); const purchase = (id && document.getElementById(id)) || document.querySelector('product-info,form[action*="/cart/add"]'); const mobile = matchMedia('(max-width:760px)');
      if (purchase && mobile.matches && 'IntersectionObserver' in window) { const bar = document.createElement('div'); bar.className = 'hb-sticky-purchase'; bar.hidden = true; bar.innerHTML = '<span class="hb-sticky-purchase__line">Steadier moods. More energy.</span><button type="button" class="hb-sticky-purchase__button">Get Started</button>'; document.body.appendChild(bar); const button = bar.querySelector('button'), reduced = matchMedia('(prefers-reduced-motion: reduce)'), hadTab = purchase.hasAttribute('tabindex'), oldTab = purchase.getAttribute('tabindex'); if (!hadTab) purchase.setAttribute('tabindex','-1'); const obscured = () => document.body.classList.contains('is-cart-open') || document.querySelector('dialog[open],.cart-drawer.active,.cart-drawer.is-open'); const sync = () => { bar.hidden = purchase.getBoundingClientRect().bottom > 0 || !!obscured(); }; this.stickyObserver = new IntersectionObserver(sync,{threshold:0}); this.stickyObserver.observe(purchase); this.stickyMutations = new MutationObserver(sync); this.stickyMutations.observe(document.body,{subtree:true,attributes:true,attributeFilter:['class','open','aria-hidden']}); button.addEventListener('click', () => { const header = document.querySelector('sticky-header'); const offset = header?.getBoundingClientRect().height || 0; window.scrollTo({top:Math.max(0,purchase.getBoundingClientRect().top+window.scrollY-offset),behavior:reduced.matches?'auto':'smooth'}); purchase.focus({preventScroll:true}); }); sync(); this.stickyCleanup = () => { this.stickyObserver.disconnect(); this.stickyMutations.disconnect(); bar.remove(); if (hadTab) purchase.setAttribute('tabindex',oldTab); else purchase.removeAttribute('tabindex'); }; }

    }


    disconnectedCallback() { this.stickyCleanup?.(); this.abort?.abort(); this.observer?.disconnect(); cancelAnimationFrame(this.frame); }
  });
})();
